import { render, staticRenderFns } from "./Possessions.vue?vue&type=template&id=87452f70&scoped=true&"
import script from "./Possessions.vue?vue&type=script&lang=js&"
export * from "./Possessions.vue?vue&type=script&lang=js&"
import style0 from "./Possessions.vue?vue&type=style&index=0&id=87452f70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87452f70",
  null
  
)

export default component.exports